import { Card } from '@/components/ui/Card'
import { Info } from 'lucide-react'

interface GateExplanationProps {
  proaGateAtivo?: boolean
}

export function GateExplanation({ proaGateAtivo = true }: GateExplanationProps) {
  return (
    <Card className="p-5" data-testid="gate-explanation">
      <div className="flex items-start gap-3">
        <Info className="text-brand-blue mt-0.5 shrink-0" size={20} />
        <div>
          <h4 className="text-sm font-semibold text-white mb-2">
            Como funciona o sistema de gates
          </h4>
          {!proaGateAtivo && (
            <p className="text-sm text-yellow-400 mb-2" data-testid="gate-proa-inactive">
              Gate PROA desativado para este ciclo
            </p>
          )}
          <ul className="space-y-1.5 text-sm text-brand-gray">
            <li>• Cat 1 (PROA): Sempre paga proporcionalmente ao atingimento</li>
            <li>• Cat 2+ (Individuais): Bloqueadas se PROA &lt; 100%</li>
            <li>• Gates inter-categoria: Algumas dependem de mínimo em outra categoria</li>
          </ul>
        </div>
      </div>
    </Card>
  )
}
